import { Dialog, DialogContent, DialogHeader, DialogTitle } from "src/components/dialogue/radix-dialog";
import EditLeaveForm from "./EditLeaveForm";
import { LeaveRequest } from "src/redux/types/_attendance.type";


const EditLeaveDialog = ({leave, open, close}: { leave: LeaveRequest, open: boolean, close: () => void}) => {
  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="bg-card max-w-5xl">
        <DialogHeader>
          <DialogTitle>Edit Leave</DialogTitle>
          <EditLeaveForm leave={leave} close={close}/>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}

export default EditLeaveDialog